import i18next from 'i18next';

i18next.addResources('es_CL', 'CheckoutOrderDetail', {
  title: 'Resumen',
  minDeliveryFeeText: 'Delivery gratis desde {{minValue}}',
  subtotal: 'Subtotal:',
  total: 'Total:',
  confirm: 'Confirmar pedido',
  cancel: 'Deshacer Pedido',
  totalSaved: 'Cupón / Gift Card aplicado:',
  delivery: 'Delivery:',
  andOur: ' y nuestra ',
  tip: 'Propina:',
  papaPointsUsed: 'Papa Puntos utilizados',
  dontLosePoints: 'No pierdas tus ',
  hoverPointsMessage: 'Inicia sesión o regístrate para canjearlos en tu siguiente compra.',
  papaPointsNextDay: 'Los Papa Puntos serán sumados al día siguiente de su compra',
  papaPointsHorizontal: '<span>Papa</span> Puntos',
  toAddPapaPoints: 'por sumar',
  addMoreOrChangeToPickup:
    '¿Deseas <linkToHome>{{addMoreProducts}}</linkToHome> a tu pedido o <openChangeAddressModal>{{changeToPickup}}</openChangeAddressModal>?',
  tax: 'Impuesto {{taxName}} ({{taxPercentage}}%):',
  papaPointsBenefits: 'Beneficio Papa Puntos:',
  addMoreProducts: 'Añade más productos',
  changeToPickup: 'Cambiar a retiro',
  addMoreProductsOrPickup:
    'Añade más productos o <openChangeAddressModal>cambia a retiro</openChangeAddressModal>',
  minimumAmountForDelivery: 'Te faltan <text>{{amount}}</text> para llegar al pedido mínimo a domicilio.',
  policiesAndConditionsBool:
    'Acepto las Política de privacidad <linkToPolicies><iconLink /></linkToPolicies> y declaro haber leído y aceptado nuestras condiciones generales de venta <sellingConditions><iconLink /></sellingConditions>.',
  papaPuntosHorizontal: '<span>Papa</span> Puntos',
  minPriceWithPoints: 'Para canjear tus Papa Puntos, tu pedido debe sumar al menos <text>{{amount}}</text>.',
  addProductsToUsePoints: '¡Añade más productos y aprovecha tus puntos!'
});

i18next.addResources('es_ES', 'CheckoutOrderDetail', {
  changeToPickup: 'Cambiar a recoger',
  delivery: 'Servicio de entrega:',
  addToDeliveryFeeText:
    'Solo te faltan <amountvalue>{{amount}}</amountvalue> en tu cesta para que tu envío sea gratuito.',
  addSmallOrderText:
    'Añade <sumvalue>{{sum}}</sumvalue> y ahórrate <penaltyvalue>{{penalty}}</penaltyvalue> por pedido pequeño.',
  smallOrder: 'Pedido pequeño:',
  papaPuntosHorizontal: '<span>Papa</span> Puntos',
  toAddPapaPoints: 'que vas a acumular',
  dontLosePoints: 'No dejes escapar tus ',
  papaPointsNextDay: 'Los Papa Puntos aparecerán en tu cuenta al día siguiente de realizar tu pedido',
  hoverPointsMessage: 'Inicia sesión para poder acumular Puntos.'
});

i18next.addResources('pt_PT', 'CheckoutOrderDetail', {
  title: 'Resumo',
  minDeliveryFeeText: 'Frete grátis a partir de {{minValue}}',
  addToDeliveryFeeText:
    'Só precisa de ter <amountvalue>{{amount}}</amountvalue> no seu carrinho para que o envio seja gratuito.',
  addSmallOrderText:
    'Adicione <sumvalue>{{sum}}</sumvalue> e poupe <penaltyvalue>{{penalty}}</penaltyvalue> por taxa de encomenda pequena.',
  smallOrder: 'Pedido pequeno:',
  subtotal: 'Subtotal',
  total: 'Total',
  confirm: 'Confirme o pedido',
  cancel: 'Desfazer o pedido',
  totalSaved: 'Cupão / Gift Card aplicado:',
  delivery: 'Delivery:',
  andOur: ' e nossa ',
  tip: 'Gorjeta:',
  addMoreOrChangeToPickup:
    'Deseja <linkToHome>{{addMoreProducts}}</linkToHome> em seu pedido ou <openChangeAddressModal>{{changeToPickup}}</openChangeAddressModal>?',
  tax: 'Imposto {{taxName}} ({{taxPercentage}}%):',
  dontLosePoints: 'Não deixes escapar os teus ',
  hoverPointsMessage: 'Inicia sessão para poderes acumular Pontos.',
  papaPointsNextDay: 'Os Papa Pontos aparecerão na tua conta no dia seguinte à realização da tua encomenda.',
  papaPuntosHorizontal: '<span>Papa</span> Pontos',
  toAddPapaPoints: 'que vais somar',
  papaPointsBenefits: 'Papa Pontos de Benefício:',
  papaPointsUsed: 'Papa Pontos usados',
  addMoreProducts: 'Adicionar mais produtos',
  changeToPickup: 'Troque para take-away',
  minimumAmountForDelivery:
    'Faltam <text>{{amount}}</text> para atingir o valor mínimo de entrega ao domicílio.',
  policiesAndConditionsBool:
    'Aceito a Política de Privacidade <linkToPolicies><iconLink /></linkToPolicies> e declaro que li e aceito as nossas condições gerais de venda <sellingConditions><iconLink /></sellingConditions>.',
  addMoreProductsOrPickup:
    'Adicione mais produtos ou <openChangeAddressModal>altere para retirada</openChangeAddressModal>',
  minPriceWithPoints:
    'Para trocar os teus Papa Pontos, a tua encomenda deve totalizar pelo menos <text>{{amount}}</text>.',
  addProductsToUsePoints: 'Adiciona mais produtos e aproveita os teus pontos!'
});
